// extracted by mini-css-extract-plugin
module.exports =  {"bottom-divider":"xQDcuS","bottomDivider":"xQDcuS"};